/**
 * Security Cleanup Utility
 * Removes all insecure data from localStorage for security compliance
 */

export const performSecurityCleanup = (): void => {
  console.log('🔒 SECURITY: Performing localStorage cleanup...');
  
  try {
    // Remove insecure user authentication data
    localStorage.removeItem('dream11-user');
    localStorage.removeItem('dream11-users'); // Contains plain text passwords!
    
    // Remove old rate limiting data (now handled server-side)
    const keysToRemove: string[] = [];
    
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && (
        key.startsWith('ai-chat-count-') ||
        key.startsWith('ai-chat-last-reset-') ||
        key.startsWith('migration-completed-')
      )) {
        keysToRemove.push(key);
      }
    }
    
    // Remove the flagged keys
    keysToRemove.forEach(key => {
      localStorage.removeItem(key);
      console.log(`🧹 Removed insecure key: ${key}`);
    });
    
    console.log('✅ Security cleanup completed');
    
    // Show security notice to user
    if (keysToRemove.length > 0) {
      console.warn('🚨 SECURITY NOTICE: Removed insecure authentication data from localStorage');
      console.warn('📢 Please sign in again using Supabase authentication for enhanced security');
    }
    
  } catch (error) {
    console.error('❌ Error during security cleanup:', error);
  }
};

export const isSecurityCleanupNeeded = (): boolean => {
  return !!(
    localStorage.getItem('dream11-user') ||
    localStorage.getItem('dream11-users') ||
    Object.keys(localStorage).some(key => 
      key.startsWith('ai-chat-count-') || 
      key.startsWith('ai-chat-last-reset-')
    )
  );
}; 